import React, { createContext } from 'react';
import { useResolveController } from '../../hooks';
export var ControllerContext = /*#__PURE__*/createContext(undefined);
export var ControllerWrapper = function ControllerWrapper(_ref) {
  var Controller = _ref.Controller;
  var ctrl = useResolveController(Controller);
  var View = ctrl.__controller__.view;
  return /*#__PURE__*/React.createElement(ControllerContext.Provider, {
    value: ctrl
  }, /*#__PURE__*/React.createElement(View, null));
};